module.exports = __webpack_public_path__ + "static/img/facebg2.26d9924.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facebg2.png
// module id = E/da
// module chunks = 1